import { FeatureGroupType } from '@app/license-management/types/feature-group'
import type { LicensePoolLabel } from '@app/license-management/types/license-pool'
import { isUnlimitedLicensePool } from './is-unlimited-license-pool'
import type { LicensePool } from '@app/license-management/types/license-pool'

export const CUSTOMER_FACING_CURRICULUM_NAME = 'Everyday Speech Curriculum'
export const CUSTOMER_FACING_SITE_PLAN_NAME = 'Everyday Speech Curriculum - Site Plan'
export const CUSTOMER_FACING_PILOT_NAME = 'Everyday Speech Curriculum - Pilot'
export const CUSTOMER_FACING_SUPER_ADMIN_NAME = 'SuperAdmin License'

export type CustomerFacingLicenseNameInput =
  | { label: LicensePoolLabel | undefined }
  | { unlimitedLicenses: boolean }
  | { licensePool: LicensePool }

export const getCustomerFacingLicenseName = (input: CustomerFacingLicenseNameInput): string | null => {
  if ('licensePool' in input) {
    return getCustomerFacingLicenseNameFromPool(input.licensePool)
  }

  if ('label' in input) {
    return getCustomerFacingLicenseNameFromLabel(input.label)
  }

  if ('unlimitedLicenses' in input) {
    return input.unlimitedLicenses ? CUSTOMER_FACING_SITE_PLAN_NAME : CUSTOMER_FACING_CURRICULUM_NAME
  }

  return null
}

const getCustomerFacingLicenseNameFromLabel = (label: LicensePoolLabel | undefined): string | null => {
  switch (label) {
    case 'user':
    case 'team':
      return CUSTOMER_FACING_CURRICULUM_NAME
    case 'site':
      return CUSTOMER_FACING_SITE_PLAN_NAME
    case 'admin':
      return CUSTOMER_FACING_SUPER_ADMIN_NAME
    case 'pilot':
      return CUSTOMER_FACING_PILOT_NAME
    default:
      return null
  }
}

const getCustomerFacingLicenseNameFromPool = (pool: LicensePool): string | null => {
  const fromLabel = getCustomerFacingLicenseNameFromLabel(pool.label)
  if (fromLabel) {
    return fromLabel
  }

  if (isUnlimitedLicensePool(pool)) {
    return CUSTOMER_FACING_SITE_PLAN_NAME
  }

  const slug = pool.featureGroup?.slug
  if (slug === FeatureGroupType.USER || slug === FeatureGroupType.TEAM) {
    return CUSTOMER_FACING_CURRICULUM_NAME
  }

  return null
}
